import Search from "./modules/Search";
import Like from "./modules/Like";
import View from "./modules/View";
import ApplicationStatus from "./modules/ApplicationStatus";
import GlobalMenus from "./modules/Menu";

document.addEventListener("DOMContentLoaded", () => {
  // Initialize globally
  // new Search();
  new GlobalMenus();

  // Conditional JS
  // Company or Jobs post single
  if (
    document.body.classList.contains("single-company") ||
    document.body.classList.contains("single-jobs")
  ) {
    new View();
    if (document.body.classList.contains("logged-in")) {
      new Like();
    }
  }

  // My Page - Application status management (company status dropdown or user withdraw button)
  if (
    document.querySelector(".application-status-select") ||
    document.querySelector(".application-withdraw-btn")
  ) {
    new ApplicationStatus();
  }
});
